import {NgStyle} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

import {OphAvatarComponent} from '../../shared/design/oph-avatar/oph-avatar.component';
import {Team} from '../shared/model/team';

@Component({
  selector: 'teams-members-avatars',
  standalone: true,
  imports: [OphAvatarComponent, NgStyle],
  templateUrl: './teams-members-avatars.component.html',
  styleUrl: './teams-members-avatars.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsMembersAvatarsComponent {
  team = input<Team>();

  AVATARS_MARGING_LEFT = 1.2; // in rem
  teamLength = computed(() => this.team()?.users?.length || 0);
}
